export default __webpack_public_path__ + "assets/better-decision-making.14968f81.svg";